







import { Component, Mixins, Prop, Emit } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class FuzzyDateSelectButton extends Mixins() {
  @Prop()
  label: string;

  @Prop()
  value: Date | string | (() => Date) | (() => string);

  @Prop()
  minWidth: string;

  get description(): string {
    return this.isValueString
      ? "文字列として「" + this.getValue() + "」を入力します。"
      : this.label + "を選択します。";
  }

  get isValueString(): boolean {
    return (typeof this.value === "string")
        || (!(this.value instanceof Date) && (typeof this.value() === "string"));
  }

  getValue(): Date | string {
    return ((typeof this.value === "string") || (this.value instanceof Date))
      ? this.value
      : this.value();
  }

  get style(): any {
    return {
      minWidth: this.minWidth,
    };
  }

  @Emit()
  select(value: Date | string): void {}

  onClicked(): void {
    this.select(this.getValue());
  }
}
